var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeMute2 = function SvgVolumeMute2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-mute-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "volume-mute--speaker-remove-volume-control-audio-music-mute-off-cross-entertainment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.957 5.625L10.207 8.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.207 5.625L12.957 8.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.33268 5.16659H1.95768C1.4581 5.16659 1.04102 5.58367 1.04102 6.08326V7.91659C1.04102 8.41617 1.4581 8.83326 1.95768 8.83326H3.33268L6.91685 11.4091C7.5081 11.8188 8.35877 11.3871 8.37435 10.6666V3.33326C8.3791 3.17124 8.33874 3.01109 8.25775 2.87069C8.17677 2.73028 8.05836 2.61514 7.91574 2.53813C7.77312 2.46111 7.6119 2.42525 7.45009 2.43454C7.28827 2.44384 7.13221 2.49792 6.99935 2.59076L3.33268 5.16659Z",
    stroke: "white",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeMute2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "volume-mute-2.9e0aa2c5a887e3cf0c544f160382165f.svg";